import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { IonIcon } from 'controls'

import { buttons } from 'theme/commonStyles'
import styles, { controlLikedStyles } from './styles'

const ControlLiked = ({ isLiked, handleLike, isRejected, handleRejected }) => (
  <Fragment>
    <button className="nex-btn-empty liked-button">
      <IonIcon
        size="large"
        icon={isLiked ? 'md-heart' : 'md-heart-empty'}
        className={classnames('control-icon liked-icon', {
          'is-liked': isLiked
        })}
        onClick={(e) => {
          e.stopPropagation()
          handleLike()
        }}
      />
    </button>

    {!isRejected && (
      <button className="nex-btn-empty reject-action">
        <IonIcon
          size="large"
          className="control-icon"
          icon="md-close-circle-outline"
          onClick={(e) => {
            e.stopPropagation()
            handleRejected()
          }}
        />
      </button>
    )}
    <style jsx>{buttons}</style>
    <style jsx>{controlLikedStyles}</style>
  </Fragment>
)

ControlLiked.propTypes = {
  isLiked: PropTypes.bool.isRequired,
  isRejected: PropTypes.bool.isRequired,
  handleLike: PropTypes.func.isRequired,
  handleRejected: PropTypes.func.isRequired,
}

ControlLiked.defaultProps = {
  handleRejected: () => {},
  handleLike: () => {}
}

export default ControlLiked